import React from 'react';
import MainSidebar from './MainSidebar';
import { FiFileText, FiShoppingCart, FiList } from 'react-icons/fi';

export default function SalesSidebar() {
  const menuItems = [
    {
      id: 'proposals',
      title: 'Commercial proposals',
      links: [
        { path: '/sales/proposals', label: 'List', icon: FiFileText }
      ]
    },
    {
      id: 'orders',
      title: 'Sales Orders',
      links: [
        { path: '/sales/orders', label: 'List', icon: FiShoppingCart }
      ]
    },
    {
      id: 'invoices',
      title: 'Customer Invoices',
      links: [
        { path: '/sales/records', label: 'List', icon: FiList }
      ]
    }
  ];
  
  return <MainSidebar moduleName="Commercial & Sales" menuItems={menuItems} />;
}